import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  machine: {
    width: "100%",
    maxWidth: "480px",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    position: "relative",
    minWidth: "480px",
    flexDirection: "column",

    [theme.breakpoints.down("md")]: {
      marginRight: "40px",
    },

    [theme.breakpoints.down("sm")]: {
      minWidth: "360px",
      maxWidth: "360px",

      marginRight: "24px",
    },
  },

  machineBg: {
    width: "100%",
  },

  numberReels: {
    position: "absolute",
    display: "flex",
    right: "10%",
    top: "40%",
    gap: "8px",
    transform: "translate(0, -50%)",
    padding: "10px",

    [theme.breakpoints.down("sm")]: {
      top: "38%",
    },
  },

  reelBar: {
    width: "100%",
    objectFit: "contain",
    position: "absolute",
    top: "50%",
    transform: "translate(-10px, -50%)",
  },

  reelBg: {
    width: "100px",

    zIndex: 1,

    [theme.breakpoints.down("sm")]: {
      width: "72px",
    },
  },

  reelHighlight: {
    width: "84%",

    zIndex: 1,
    position: "absolute",
    left: "8%",
    top: "5%",
    mixBlendMode: "overlay",
  },

  reelBgContainer: {
    display: "flex",
    position: "relative",
    overflow: "hidden",
  },

  reelContainer: {
    position: "absolute",
    zIndex: 1,
    height: "100%",
    width: "100%",
    WebkitMaskImage:
      "linear-gradient(rgba(0,0,0,0) 0%, rgba(0,0,0,0) 10%, rgba(255,255,255,1) 20%, rgba(255,255,255,1) 80%, rgba(0,0,0,0) 90%, rgba(0,0,0,0) 100%)",
    display: "flex",
    justifyContent: "center",
  },

  reel: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    alignItems: "center",
    zIndex: 1,
    bottom: -12,

    [theme.breakpoints.down("sm")]: {
      bottom: -12,
    },
  },

  reelSymbol: {
    width: "64px",
    height: "64px",

    [theme.breakpoints.down("sm")]: {
      width: "48px",
      height: "48px",
    },
  },

  balance: {
    display: "flex",
    width: "420px",
    padding: "8px 0",
    alignItems: "center",
    gap: "8px",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    marginRight: "8px",

    [theme.breakpoints.down("sm")]: {
      width: "315px",
    },
  },

  balanceCashIcon: {
    width: 20,
    height: 20,
  },

  balanceText: {
    fontFamily: "Philosopher",
    fontWeight: 900,
    fontSize: 24,

    textAlign: "center",
    fontStyle: "normal",
    lineHeight: "normal",
    background:
      "linear-gradient(179deg, rgb(247, 241, 246) 14.45%, rgb(180, 162, 100) 109.08%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text", // Webkit-prefixed background clip for Safari
    WebkitTextFillColor: "transparent", // Webkit-prefixed text fill for Safari
    color: "transparent", // Ensures text is transparent in non-webkit browsers
    textShadow: "1px 0 4px rgb(180 160 100 / 56%)",
  },
}));

export default styles;
